module.exports = __webpack_public_path__ + "static/media/ic_logout.8384df51.svg";